module.exports = {
    title: '商情資料查詢系統',
    /** 
     * @type {boolean}
     * @description
     */
    tagsView: true,
    /**
     * @type {boolean}
     * @description
     */
    fixedHeader: false,
    /**
     * @type {boolean}
     * @description
     */
    sidebarLogo: false
}